import Progress from './progress';
export default Progress;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/progress/index.js
// module id = 331
// module chunks = 3